import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';
import { LastLocationProvider } from 'react-router-last-location';
import { I18nProvider, LayoutSplashScreen, ThemeProvider } from './_metronic';
import { Routes } from './app/router/Routes';
import { IntlProvider } from 'rsuite';
import esAR from 'rsuite/lib/IntlProvider/locales/es_AR';
import useTheme from './app/hooks/useTheme';
import { Helmet } from 'react-helmet';
import AwsCWRum from './config/rum';

AwsCWRum();

export default function App ({ store, persistor }) {
    const theme = useTheme();
    return (
        <>
            <Helmet>
                <title>{theme.title}</title>
                <link
                    rel="icon"
                    type="image/x-icon"
                    href={`/${theme.name}/favicon.ico`}
                />

            </Helmet>
            <Provider store={store}>
                {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
                <PersistGate persistor={persistor} loading={<LayoutSplashScreen />}>
                    {/* Add high level `Suspense` in case if was not handled inside the React tree. */}
                    <React.Suspense fallback={<LayoutSplashScreen />}>
                        {/* Override `basename` (e.g: `homepage` in `package.json`) */}
                        <BrowserRouter>
                            {/* This library only returns the location that has been active before the recent location change in the current window lifetime. */}
                            <LastLocationProvider>
                                {/* Provide Metronic theme overrides. */}
                                <ThemeProvider>
                                    {/* Provide `react-intl` context synchronized with Redux state.  */}
                                    <I18nProvider>
                                        <IntlProvider locale={esAR}>
                                            {/* Render routes with provided `Layout`. */}
                                            <Routes />
                                        </IntlProvider>
                                    </I18nProvider>
                                </ThemeProvider>
                            </LastLocationProvider>
                        </BrowserRouter>
                    </React.Suspense>
                </PersistGate>
            </Provider>
        </>
    );
}
